import { Component, OnDestroy, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, UntypedFormGroup, FormGroupDirective, UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-other-form',
    templateUrl: './other-form.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]]
        }
    ]
})
export class OtherFormComponent implements OnInit, OnDestroy {
    formControlName = 'other';
    formGroup!: UntypedFormGroup;
    private readonly subscriptions = new Subscription();

    showWasEverlightInformedOfDiscrepancy = false;
    showDetailsOfDiscrepancy = false;

    constructor(public parent: FormGroupDirective, private readonly formBuilder: UntypedFormBuilder) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({});
        (this.parent.form.get('advisedSeriousIncident') as UntypedFormGroup).addControl(this.formControlName, this.formGroup);
    }

    ngOnDestroy() {
        //if a formGroup already exists in the parent when ngOnInit runs, new formGroup wouldn't work properly
        (this.parent.form.get('advisedSeriousIncident') as UntypedFormGroup).removeControl(this.formControlName);
        this.subscriptions.unsubscribe();
    }
}
